import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import styles from "./ListLocation.module.css";
import { DownIcon, LeftIcon } from "../../../components/Icons/Icons";
import WareHouse from "./WareHouse";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import axiosClient from "../../../services/axiosClient";
import Loading from "../../../components/Loading";
import { sorterArray } from "../../../utils";
import { MapContext } from "../../../contexts";
const cx = classNames.bind(styles);
const ListLocation = ({ name, indexLocation, icon, show, onClick, value, code, isGroup, filter, wareHouses }) => {
  const {setWareCode,setGroup,zoom, setZoom} = useContext(MapContext)
  // const [wareHouses, setWareHouse] = useState([])
  const [warehouse, setWarehouse] = useState([])
  const [loading, setLoading] = useState(false)

  const [provinceCode, setProvinceCode] = useState(isGroup ? null : code)
  const [districtCode, setDistrictCode] = useState(null)
  const [communeCode, setCommuneCode] = useState(null)
  const [groupCode, setGroupCode] = useState(isGroup ? code : null)
  const [statusCode, setStatusCode] = useState(null)
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext()

  useEffect(() => {
    if (filter && filter.length > 0) {
      filter.forEach((item) => {
        switch (item.type) {
          case 'group':
            if (item.code) {
              setGroupCode(item.code);
            }
            break;
          case 'province':
            if (item.code) {
              setProvinceCode(item.code);
            }
            break;
          case 'district':
            setDistrictCode(item.code);
            break;
          case 'commune':
            setCommuneCode(item.code);
            break;
          case 'status':
            setStatusCode(item.code)
            break;
          default:
            return 0
        }
      })
    } else if (isGroup) {
      setGroupCode(code)
    } else {
      setProvinceCode(code)
    }
  }, [filter, isGroup, code])
  const onClicks = async (e, index,code) => {
    console.log("zo");
    setZoom(5)
    setLoading(true)
    onClick(index);
    setGroup(code)
    setLoading(false)
    const data = wareHouses?.map((item) => {
      return {
        ...item,
        INDEX_LOCATION: code,
      }
    })
    // dispatch(actions.getListWareHouse(data))
    dispatch(actions.getViewPort(null))
  };

  
  // format data of warehouse
  useEffect(() => {
    if (wareHouses) {
      const data = wareHouses.map((item, index) => {
        return {
          code: item.WAREHOUSE_CODE,
          name: item.WAREHOUSE_NAME,
          longitude: item.LONGITUDE,
          latitude: item.LATITUDE,
          isShow: false,
          icon: <LeftIcon />,
          isCheck: false,
        };
      });
      if (data) {
        const wareHouseSort = sorterArray(data, 'name')
        setWarehouse(wareHouseSort);
      }
    }
  }, [wareHouses]);


  const handleShowCam = (value) => {
    const data = warehouse.map((item, index) => {
      if (index === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      } else {
        return {
          ...item,
          isShow: false,
          icon: <LeftIcon />,
        };
      }

    });
    
    setWarehouse(data);
    
  };

  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(e, indexLocation,code)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {show && (
        <>
          {loading ? <Loading /> : (
            <div className={cx("warehouse")}>
              {warehouse &&
                warehouse.map((item, index) => (
                  <WareHouse
                    data={item}
                    indexWareHouse={index}
                    indexLocation={indexLocation}
                    onClick={handleShowCam}
                    parentShow={show}
                    key={index}
                    show={item.isShow}
                    icon={item.icon}
                    name={item.name}
                    setWarehouse={setWarehouse}
                    code={item.code}
                    groupCode={groupCode}
                    value={value}
                    status={statusCode}
                    latitude={item.latitude}
                    longitude={item.longitude}
                  />
                ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
ListLocation.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  wareHouses: PropTypes.array,
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ListLocation;
